module.exports = __webpack_public_path__ + "static/media/2Thumbnail.53f42099.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2Thumbnail.jpg
// module id = 1465
// module chunks = 33